/**
 * The one button a document card may carry, read from the tool call's `action` argument. Plain .ts
 * so `node --test` can load it.
 */

export interface DocumentAction {
	label: string;
	message: string;
}

const MAX_LABEL = 20;
const MAX_MESSAGE = 200;

/**
 * Null draws no button. The message goes out as the user's own, so it may only start a workflow:
 * free text written by the model never gets sent under their name.
 */
export function documentAction(value: unknown): DocumentAction | null {
	if (!value || typeof value !== "object") return null;
	const { label, message } = value as Record<string, unknown>;
	if (typeof label !== "string" || typeof message !== "string") return null;
	const action = { label: label.trim(), message: message.trim() };
	if (!action.label || action.label.length > MAX_LABEL) return null;
	if (!action.message.startsWith("/") || action.message.length > MAX_MESSAGE) return null;
	return action;
}
